<template>
  <vs-row vs-type="flex" vs-w="12">
    <vs-popup class="holamundo" title="Kampanya Sil" :active.sync="deletePopupActive" v-esc="escape">
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Kampanyayı Silmek İstediğinize Eminmisiniz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deletePopupActive = false;deletedId = null">Vazgeç</vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
          @click="removeCampaign(deletedId)">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <new-campaign ref="newCampaign" @success="reloadData" />
    <vs-row vs-type="flex" vs-w="12" id="campaignPageHeader" vs-align="center">
      <vx-tooltip v-if="$isCenterBranch() && isNewCampaignPermission" text="Yeni Kampanya" position="top">
        <vs-button @click="openNewCampaignPage" class="panel-action text-success xlarge-button panel-action-box-shadow"
          color="transparent" icon-pack="feather" icon="icon-plus">
        </vs-button>
      </vx-tooltip>
      
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="campaignPageContent">
      <vs-row vs-type="flex" vs-w="12" id="campaignList">
        <vs-col vs-type="flex" class="campaingItem" v-for="campaign in campaigns" :key="campaign.id">
          <vs-row vs-type="block" vs-w="12">
            <vs-row class="campaignTitle py-1" vs-type="flex" vs-w="12">
              <vx-tooltip :text="campaign.title" color="primary" position="top" class="w-full flex">
              <span class="text-small text-primary bold">
                {{campaign.title}}
              </span>
              </vx-tooltip>
            </vs-row>
            <vs-row class="border-all" vs-type="flex" vs-w="12" style="background-color:#00000070;position: relative;">
              <div class="campaignImgDiv m-auto">
                <img :src="$baseUrl + '/' + campaign.image" alt="img" class="responsive">
              </div>
              <span class="text-smaller py-1 px-2 campaignDescription text-white weight-600">
                {{campaign.description}}
              </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="border-all px-2">
              <vs-row vs-type="flex" vs-w="12" class="mt-2">
                <span class="text-smaller text-dark weight-600 mr-auto">
                  {{getDisplayUsedBy(campaign)}} kez
                </span>
                <span class="text-smaller text-dark weight-600 ml-auto">
                  {{campaign.totalUsageLimit ? campaign.totalUsageLimit + ' kez' : 'Sınırsız'}}
                </span>
                <vx-tooltip v-if="campaign.totalUsageLimit" :text="'Kalan Kullanım : ' + (campaign.totalUsageLimit - getDisplayUsedBy(campaign)).toString() "
                  color="primary" position="top" class="w-full">
                  <vs-progress :height="8" :percent="getDisplayUsedBy(campaign) * 100 / campaign.totalUsageLimit"
                    :color="getDisplayUsedBy(campaign) == campaign.totalUsageLimit ? 'danger' : 'success'">
                  </vs-progress>
                </vx-tooltip>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="my-1">
                <span class="text-smaller text-dark weight-600 mr-auto">
                  {{formatDate(campaign.startDate)}}
                </span>
                <span class="text-smaller text-dark weight-600 ml-auto">
                  {{formatDate(campaign.endDate)}}
                </span>
                <vx-tooltip :text="campaign.leftTime" color="primary" position="top" class="w-full">
                  <vs-progress :height="8" :percent="campaign.toFinish"
                    :color="campaign.toFinish == 100 ? 'danger' : 'success'">
                  </vs-progress>
                </vx-tooltip>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" class="py-2">
                <vx-tooltip :text="campaign.isMoodFelek ? 'Moodfelekte Gösteriliyor !' : 'Moodfelekte Gösterilmiyor'" color="primary"
                  position="top">
                  <vs-button disabled
                    icon-pack="feather" icon="icon-chrome" :color="campaign.isMoodFelek ? 'success' : 'danger'" />
                </vx-tooltip>
                <vx-tooltip :text="campaign.isPublished ? ($isCenterBranch() && isCampaignWritePermission ? 'Yayından Kaldır !' : 'Yayında') : ($isCenterBranch() && isCampaignWritePermission ? 'Yayınla !' : 'Yayında Değil')" color="primary"
                  position="top">
                  <vs-button :disabled="!$isCenterBranch() || !isCampaignWritePermission" @click="setCampaignPublish(campaign.id)" class="ml-1" icon-pack="feather"
                    icon="icon-monitor" :color="campaign.isPublished ? 'success' : 'danger'" />
                </vx-tooltip>
                <vx-tooltip class="ml-1" text="Detay Rapor" color="primary" position="top">
                  <vs-button @click="openReport(campaign.id)" icon-pack="feather"
                    icon="icon-bar-chart-2" color="warning" />
                </vx-tooltip>
                <vx-tooltip v-if="isCampaignWritePermission && $isCenterBranch()" class="ml-auto" text="Sil" color="primary" position="top">
                  <vs-button :disabled="campaign.isPublished || campaign.isPrivate || campaign.isMoodFelek" @click="deletePopupActive = true;deletedId = campaign.id;"
                    icon-pack="feather" icon="icon-trash" color="danger" />
                </vx-tooltip>
                <vx-tooltip class="ml-1" text="Ayarlar" color="primary" position="top">
                  <vs-button @click="editCampaign(campaign.id)" icon-pack="feather"
                    icon="icon-settings" color="primary" />
                </vx-tooltip>
              </vs-row>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-row>

    <!-- KAMPANYA KATILIM DETAY RAPOR MODALI -->
    <vs-popup class="campaign-report-popup" :title="reportData && reportData.campaignTitle ? 'Kampanya Katılım Raporu: ' + reportData.campaignTitle : 'Kampanya Katılım Raporu'" :active.sync="reportPopupActive" button-close-hidden>
      <div v-if="loadingReport" class="p-4 text-center">
        <vs-spinner color="primary" type="border"></vs-spinner>
        <p class="mt-2 text-primary bold">Rapor Yükleniyor...</p>
      </div>
      <div v-else>
        <!-- Özet Kartları -->
        <vs-row vs-type="flex" vs-w="12" class="mb-4">
          <vs-col vs-w="4" class="px-2">
            <vx-card class="bg-primary text-white text-center py-2">
              <h3 class="text-white bold">{{ reportData.totalUsageCount || 0 }}</h3>
              <span class="text-small">Toplam Katılım</span>
            </vx-card>
          </vs-col>
          <vs-col vs-w="4" class="px-2">
            <vx-card class="bg-success text-white text-center py-2">
              <h3 class="text-white bold">{{ reportData.uniqueCustomerCount || 0 }}</h3>
              <span class="text-small">Tekil Müşteri</span>
            </vx-card>
          </vs-col>
          <vs-col vs-w="4" class="px-2">
            <vx-card class="bg-warning text-white text-center py-2">
              <h3 class="text-white bold">₺{{ (reportData.totalDiscountAmount || 0).toFixed(2) }}</h3>
              <span class="text-small">Toplam İndirim</span>
            </vx-card>
          </vs-col>
        </vs-row>

        <!-- Excel İndir Butonu -->
        <vs-row vs-type="flex" vs-w="12" class="mb-3" vs-justify="space-between" vs-align="center">
          <span class="text-small text-muted font-weight-bold">Katılım Detay Listesi</span>
          <vs-button color="success" type="relief" icon-pack="feather" icon="icon-download" @click="exportToExcel">
            Excel İndir (.csv)
          </vs-button>
        </vs-row>

        <!-- Detay Tablosu -->
        <vs-table max-items="10" pagination :data="reportData.usages || []" search class="campaign-report-table">
          <template slot="thead">
            <vs-th sort-key="orderId">Sipariş No</vs-th>
            <vs-th sort-key="customerName">Müşteri Adı</vs-th>
            <vs-th sort-key="customerPhone">Telefon / Kodu</vs-th>
            <vs-th sort-key="branchName">Şube</vs-th>
            <vs-th sort-key="usageDate">Tarih</vs-th>
            <vs-th sort-key="productName">Ürün / Kalem</vs-th>
            <vs-th sort-key="discountedItemCount">İndirimli Ürün Adeti</vs-th>
            <vs-th sort-key="discountAmount">Toplam İndirim Tutarı</vs-th>
            <vs-th sort-key="status">Durum</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.orderId">
                <span class="bold text-primary">{{ tr.orderId ? '#' + tr.orderId : '-' }}</span>
              </vs-td>
              <vs-td :data="tr.customerName">
                <span class="bold">{{ tr.customerName }}</span>
              </vs-td>
              <vs-td :data="tr.customerPhone">
                {{ tr.customerPhone }} <span v-if="tr.customerCode" class="text-small text-muted">({{ tr.customerCode }})</span>
              </vs-td>
              <vs-td :data="tr.branchName">
                {{ tr.branchName }}
              </vs-td>
              <vs-td :data="tr.usageDate">
                {{ formatDate(tr.usageDate) }}
              </vs-td>
              <vs-td :data="tr.productName">
                {{ tr.productName }}
              </vs-td>
              <vs-td :data="tr.discountedItemCount">
                <span class="bold text-dark">{{ tr.discountedItemCount ? tr.discountedItemCount + ' Adet' : '1 Adet' }}</span>
              </vs-td>
              <vs-td :data="tr.discountAmount">
                <span class="bold text-success">₺{{ tr.discountAmount ? tr.discountAmount.toFixed(2) : '0.00' }}</span>
              </vs-td>
              <vs-td :data="tr.status">
                <vs-chip color="success">{{ tr.status }}</vs-chip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="flex-end">
        <vs-button type="filled" color="danger" @click="reportPopupActive = false">Kapat</vs-button>
      </vs-row>
    </vs-popup>
  </vs-row>
</template>

<script>
  import NewCampaign from "./NewCampaign";
  import {
    GetAllCampaigns,
    SetCampaignMoodfelek,
    SetCampaignPublish,
    DeleteCampaign,
    GetCampaignUsageReport
  } from "@/api/Campaign";
  import {isGranted} from "@/utils/auth";
  export default {
    data() {
      return {
        campaigns: [],
        tableOptions: {},
        deletePopupActive: false,
        deletedId: null,
        reportPopupActive: false,
        loadingReport: false,
        reportData: {}
      }
    },
    components: {
      NewCampaign
    },
    computed: {
      isNewCampaignPermission(){
        return isGranted("campaign_write") || this.$isSuperAdmin()
      },
      isCampaignWritePermission(){
        return isGranted("campaign_write") || this.$isSuperAdmin()
      },
      isCampaignReadPermission(){
        return isGranted("campaign_read") || isGranted("campaign_write") || this.$isSuperAdmin()
      }
    },
    methods: {
      escape() {
        if (this.deletePopupActive) {
          this.deletePopupActive = false;
          this.deletedId = null;
        }
      },
      removeCampaign(campaignId) {
        DeleteCampaign(campaignId).then(res => {
          if (res && res.status) {
            this.deletePopupActive = false;
            this.deletedId = null;
            let index = this.campaigns.findIndex(x => x.id == campaignId);
            this.campaigns.splice(index, 1);
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı !',
              text: 'Kampanya Silme İşlemi Başarılı !'
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kampanya Silme İşlemi Başarısız !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      setCampaignPublish(campaignId) {
        SetCampaignPublish(campaignId).then(res => {
          if (res && res.status == 200) {
            this.campaigns.find(x => x.id == campaignId).isPublished = res.data;
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı',
              text: res.data ? 'Kampanya Yayına Alındı !' : 'Kampanya Yayından Çıkarıldı !'
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kampanya İşlemi Başarısız !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      setCampaignMoodfelek(campaignId) {
        SetCampaignMoodfelek(campaignId).then(res => {
          if (res && res.status == 200) {
            this.campaigns.find(x => x.id == campaignId).isMoodFelek = res.data;
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı',
              text: res.data ? 'Kampanya Moodfelek\'e Eklendi !' : 'Kampanya Moodfelek\'den Çıkarıldı !'
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kampanya İşlemi Başarısız !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      editCampaign(campaignId) {
        this.$refs.newCampaign.loadNewCampaign(campaignId);
      },
      getDisplayUsedBy(campaign) {
        if (!campaign) return 0;
        // Merkez olmayan her kullanıcı (yetkisi ne olursa olsun — ör. Bölge Bayi Admin'in campaign_write
        // yetkisi var ama merkez şube değil) sadece kendi şube/bayilik kapsamındaki sayıyı görmeli.
        if (!this.$isCenterBranch()) {
          return campaign.displayUsedBy != null ? campaign.displayUsedBy : 0;
        }
        return campaign.usedBy != null ? campaign.usedBy : 0;
      },
      fetchBranchUsageCountsForCampaigns(campaignList) {
        // Backend (GetCampaignUsageReport) artık merkez olmayanlar için zaten şube/bölge bazında
        // scope edilmiş sonuç döndürüyor — burada tekrar isim bazlı filtre yapmaya gerek yok, ayrıca
        // bölge bayiliği için YANLIŞ sonuç verirdi (bayiliğin kendi adı hiçbir siparişin şube adıyla
        // eşleşmez, sadece altındaki şubelerinkiyle eşleşir).
        if (!campaignList || campaignList.length === 0) return;

        campaignList.forEach(campaign => {
          if (campaign.branchUsedBy != null) {
            this.$set(campaign, 'displayUsedBy', campaign.branchUsedBy);
            return;
          }
          if (campaign.branchUsageCount != null) {
            this.$set(campaign, 'displayUsedBy', campaign.branchUsageCount);
            return;
          }
          GetCampaignUsageReport(campaign.id).then(res => {
            if (res && res.status === 200 && res.data && res.data.usages) {
              this.$set(campaign, 'displayUsedBy', res.data.usages.length);
            }
          }).catch(() => {});
        });
      },
      openReport(campaignId) {
        this.reportPopupActive = true;
        this.loadingReport = true;
        this.reportData = {};
        GetCampaignUsageReport(campaignId).then(res => {
          this.loadingReport = false;
          if (res && res.status == 200) {
            let data = res.data || {};
            // Backend (GetCampaignUsageReport) merkez olmayanlar için zaten şube/bölge bazında scope
            // edilmiş sonuç döndürüyor, burada tekrar filtrelemeye gerek yok.
            let usages = data.usages || [];

            // Fast O(N) unique customer count calculation
            const phoneSet = new Set();
            for (let i = 0; i < usages.length; i++) {
              const p = usages[i].customerPhone;
              if (p && p !== '-') phoneSet.add(p);
            }
            let uniqueCount = phoneSet.size;
            if (uniqueCount === 0 && usages.length > 0) {
              uniqueCount = usages.length;
            }

            // Fast O(N) discount amount calculation
            let totalDiscount = 0;
            for (let i = 0; i < usages.length; i++) {
              totalDiscount += (usages[i].discountAmount || 0);
            }

            data.totalUsageCount = usages.length;
            data.uniqueCustomerCount = uniqueCount;
            data.totalDiscountAmount = totalDiscount;
            data.usages = Object.freeze(usages);

            this.reportData = data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata',
              text: 'Kampanya katılım raporu yüklenemedi!'
            });
          }
        }).catch(() => {
          this.loadingReport = false;
          this.$vs.notify({
            color: 'danger',
            title: 'Hata',
            text: 'Sunucu hatası oluştu!'
          });
        });
      },
      exportToExcel() {
        if (!this.reportData || !this.reportData.usages || this.reportData.usages.length === 0) {
          this.$vs.notify({
            color: 'warning',
            title: 'Uyarı',
            text: 'İndirilecek katılım kaydı bulunamadı!'
          });
          return;
        }

        let headers = ["Sipariş No", "Müşteri Adı", "Telefon", "Müşteri Kodu", "Şube", "Tarih", "Ürün / Kalem", "İndirimli Ürün Adeti", "Toplam İndirim Tutarı (TL)", "Durum"];
        let rows = this.reportData.usages.map(u => [
          `"${u.orderId ? '#' + u.orderId : '-'}"`,
          `"${(u.customerName || '').replace(/"/g, '""')}"`,
          `"${(u.customerPhone || '').replace(/"/g, '""')}"`,
          `"${(u.customerCode || '').replace(/"/g, '""')}"`,
          `"${(u.branchName || '').replace(/"/g, '""')}"`,
          `"${this.formatDate(u.usageDate)}"`,
          `"${(u.productName || '').replace(/"/g, '""')}"`,
          `"${u.discountedItemCount || 1}"`,
          `"${(u.discountAmount || 0).toFixed(2)}"`,
          `"${(u.status || '').replace(/"/g, '""')}"`
        ]);

        let csvContent = "\uFEFF" + [headers.join(";"), ...rows.map(e => e.join(";"))].join("\r\n");
        let blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        let link = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let campaignName = (this.reportData.campaignTitle || 'Kampanya').replace(/[/\\?%*:|"<>]/g, '_');
        link.setAttribute("href", url);
        link.setAttribute("download", `Kampanya_Raporu_${campaignName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$vs.notify({
          color: 'success',
          title: 'Başarılı',
          text: 'Kampanya katılım raporu Excel olarak indirildi!'
        });
      },
      formatDate(formatDate) {
        if (!formatDate) return "";
        let dateTime = formatDate.split("T");
        if (dateTime.length < 2) return formatDate;
        return dateTime[0] + " " + dateTime[1].substring(0, 5);
      },
      openNewCampaignPage() {
        this.$refs.newCampaign.isActive = true;
      },
      reloadData() {
        this.GetAllCampaigns();
      },
      GetAllCampaigns() {
        GetAllCampaigns(this.tableOptions).then(res => {
          if (res && res.status == 200) {
            let list = res.data.data || [];
            this.campaigns = list;
            if (!this.$isCenterBranch()) {
              this.fetchBranchUsageCountsForCampaigns(list);
            }
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kampanyalar Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      }
    },
    watch: {
      tableOptions: {
        deep: true,
        handler() {
          this.GetAllCampaigns();
        }
      }
    },
    created() {
      if (!this.isCampaignReadPermission) {
        this.$vs.notify({
          color: 'danger',
          title: 'Yetkisiz Erişim',
          text: 'Kampanyalar sayfasını görüntüleme yetkiniz bulunmamaktadır.'
        });
        this.$router.push('/');
        return;
      }
      this.tableOptions = {
        campaignId: null,
        title: null,
        description: null,
        startDate: null,
        endDate: null,
        isPublished: null,
        isMoodFelek: null
      };
    }
  }

</script>

<style>
  .campaign-report-popup .vs-popup {
    width: 85vw !important;
    max-width: 1200px !important;
    min-width: 700px !important;
  }

  .campaign-report-table .vs-table--thead th {
    padding: 10px 12px !important;
  }

  .campaign-report-table .vs-table--thead th .vs-table-text {
    justify-content: center !important;
    text-align: center !important;
    white-space: nowrap !important;
  }

  .campaign-report-table .vs-table--tbody tr td {
    padding: 12px 14px !important;
    text-align: center !important;
  }

  .campaign-report-table .vs-table--tbody tr td:nth-child(1),
  .campaign-report-table .vs-table--thead th:nth-child(1) {
    width: 22% !important;
  }

  .campaign-report-table .vs-table--tbody tr td:nth-child(2),
  .campaign-report-table .vs-table--thead th:nth-child(2) {
    width: 18% !important;
  }

  .campaign-report-table .vs-table--tbody tr td:nth-child(3),
  .campaign-report-table .vs-table--thead th:nth-child(3) {
    width: 16% !important;
  }

  .campaign-report-table .vs-table--tbody tr td:nth-child(4),
  .campaign-report-table .vs-table--thead th:nth-child(4) {
    width: 16% !important;
  }

  .campaign-report-table .vs-table--tbody tr td:nth-child(5),
  .campaign-report-table .vs-table--thead th:nth-child(5) {
    width: 14% !important;
  }

  .campaign-report-table .vs-table--tbody tr td:nth-child(6),
  .campaign-report-table .vs-table--thead th:nth-child(6) {
    width: 10% !important;
  }

  .campaign-report-table .vs-table--tbody tr td:nth-child(7),
  .campaign-report-table .vs-table--thead th:nth-child(7) {
    width: 10% !important;
  }
 
  .campaignImgDiv {
    filter: brightness(55%);
    height: 22.5vh;
    overflow: hidden;
    min-height: 150px;
    position: relative;
  }

  .campaignDescription {
    position: absolute;
    height: 22.5vh;
    overflow: hidden;
    text-shadow: 1px 1px rgba(var(--vs-primary), 1);
  }

  .campaignTitle {
    border-radius: 8px;
  }

  .campaignTitle span{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

</style>
